import { Flame, Wrench } from "lucide-react";
import { Panel, SEV } from "./util";

const KIND = { rage_click: "RAGE CLICK", repeated: "REPEATED", api_error: "API ERROR", js_error: "SCRIPT ERROR", hesitation: "HESITATION",
  bounce: "BOUNCE", gave_up: "GAVE UP", mari_help: "ASKED MARI", stuck_step: "STUCK ON STEP" };

export const Friction = ({ items }) => (
  <Panel title={`Friction finder · ${items.length} signal${items.length === 1 ? "" : "s"}`} testid="insights-friction"
    right={<Flame className="w-4 h-4 text-[#FF2BD6]" />}>
    {!items.length && <p className="text-sm text-white/45" data-testid="friction-empty">No friction detected in this window. Signals appear as he uses the app.</p>}
    <ul className="space-y-3 max-h-[520px] overflow-y-auto pr-1">
      {items.map((f, i) => (
        <li key={f.id + i} className={`border-l-2 pl-4 py-3 pr-3 ${SEV[f.severity]} transition-transform duration-200 hover:translate-x-1`} data-testid={`friction-item-${i}`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono text-[10px] tracking-widest">{KIND[f.kind]}</span>
            <span className="font-mono text-[10px] uppercase opacity-70">· {f.severity}</span>
            <span className="font-mono text-[10px] text-white/45 ml-auto">{f.page} · ×{f.count}</span>
          </div>
          <p className="text-sm text-white mt-1">{f.title}</p>
          {!!f.examples.length && <ul className="mt-1 space-y-0.5">{f.examples.map((x, j) => <li key={j} className="font-mono text-[11px] text-white/50 truncate">› {x}</li>)}</ul>}
          <p className="text-xs text-white/70 mt-2 flex gap-2"><Wrench className="w-3.5 h-3.5 shrink-0 mt-0.5 text-brand" /><span><span className="text-brand">Suggested fix:</span> {f.fix}</span></p>
        </li>
      ))}
    </ul>
  </Panel>
);
